// Extracted from PromptLibrary.data to avoid circular dependency
export const DisplayCategoryKey = "displayCategory";
export const ProductNameKey = "products/name";
export const JobTypeKey = "jobType";
export const CreatedByKey = "createdBy";
export const ExtensionKey = "extension";
export const WorkgroupKey = "workgroup";
export const LikedKey = "liked";
export const OriginKey = "origin";
export const MetadataKey = "metadata";
export const RoleKey = "role";
export const DepartmentKey = "department";
export const IndustryKey = "industry";
export const EducationKey = "education";
